import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'animate.css';
import { BrowserRouter } from 'react-router-dom';

import './styles.module.css';
import './views/assets/NSIcon-Material.css';
import bugsnagClient from './bugsnag';
import { App } from './views';
import { startApp } from './events';
import store from './store';
import reportWebVitals from './reportWebVitals';

const ErrorBoundary = bugsnagClient.getPlugin('react');

store.dispatch(startApp());

ReactDOM.render(
  <ErrorBoundary>
    <Provider store={store}>
      <BrowserRouter basename="/analytics">
        <App />
      </BrowserRouter>
    </Provider>
  </ErrorBoundary>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.debug))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
